import { BlockInfoIcon } from '../ui/BlockInfoIcon';

interface WelcomeBannerProps {
  clientName: string;
  portfolioSummaryTags: string[];
  subtitle: string;
  loading?: boolean;
}

export const WelcomeBanner = ({
  clientName,
  portfolioSummaryTags,
  subtitle,
  loading = false,
}: WelcomeBannerProps) => {
  return (
    <section className="hero-banner">
      <div className="hero-content">
        <div className="hero-content__title-row">
          <h2>
            <span className="welcome-text">Welcome Back,</span>
            <br />
            {clientName || 'User'}
          </h2>
          <BlockInfoIcon blockId="hero" className="hero-content__info" />
        </div>
        <p>{subtitle}</p>
        {!loading && portfolioSummaryTags.length > 0 && (
          <div className="hero-tags" aria-label="Portfolio summary">
            {portfolioSummaryTags.map((tag, index) => (
              <span key={tag} className="hero-tags__item">
                {index > 0 && (
                  <span className="hero-tags__separator" aria-hidden="true">
                    •
                  </span>
                )}
                <span className="hero-tag">{tag}</span>
              </span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
